<template>
	<div class="user-filters-wrapper"  :class="{'fixed-header-active':$store.state.isMobile && showAdvancedSearch}"  >
		<div class="container-wrapper search-row-container-wrapper" id="user-filters-container">
			<div class="search-row-container container wide">
				<div class="search-row">
					<div class="search-row__search-bar search-bar-col">
						<b-input-group>
							<b-form-input class="input-search" placeholder="Search..." v-model="globalSearch" v-on:keyup.enter="searchGlobal"/>
							<b-input-group-append class="vdp-datepicker__search-button">
								<button type="button" class="btn" @click="searchGlobal()"><i class="icon-search"></i></button>
							</b-input-group-append>
							<b-input-group-append class="vdp-datepicker__clear-button" v-if="globalSearch">
								<button type="button" class="btn" @click="clearSearch();searchGlobal()">&times;</button>
							</b-input-group-append>

						</b-input-group>
					</div>
					<div class="search-row__filter-button d-flex hide-mobile">
						<div class="advance-search-filter" @click="toggleAdvancedSearch">
							<img src="/img/nav/icon-filter-dark-reverse.svg" alt="filter"  v-if="hasAdvancedFilters()" /><img src="/img/nav/icon-filter-dark.svg" alt="filter"  v-if="!hasAdvancedFilters()"/> 
							<span v-if="advancedFilterCount()"> {{ advancedFilterCount() }}</span> FILTERS <span class="badge badge-secondary" v-if="1 == 2 && hasAdvancedFilters()" v-html="advancedFilterCount()"></span> <img src="../assets/downarrow.svg" alt="downarrow"
							:class="{'advance-arrow': true, 'up': showAdvancedSearch}" />
						</div>

						<button type="button" class="btn search-row__filter-clear-button hide-mobile"     v-if="hasAdvancedFilters()" @click="resetArgs()">
						    &times;<span v-html="resetText"></span>
						</button>
					</div>
					<div class="search-row__actions" v-if="!$store.state.isMobile">
						<button v-if="showNewUserButton" class="quick-switch__action-button btn btn-secondary" @click="$emit('submit:newuser')">
							New User
						</button>
					</div>
				</div>
			</div>

			<div class="mobile-only page-title-bar">
				<b-row>
					<b-col cols="7" sm="7">
					<h1 class="page-title">Users</h1>
					</b-col>
					<b-col cols="5" sm="5" class="pt-2 text-right">
						<button v-if="showNewUserButton" class="mr-3 quick-switch__action-button btn btn-secondary" @click="$emit('submit:newuser')">
							New User
						</button>
					</b-col>
				</b-row>
			</div>
		</div>
		<div class="container-wrapper advance-search-container-wrapper" :class="{'expanded-wrapper': showAdvancedSearch}">
			<div id="advance-search" :class="{'expanded': showAdvancedSearch, 'container':true, 'wide':true,'advance-search-container':true}">
				<b-collapse :visible="showAdvancedSearch" class="advance-search-expandable">
					<b-row>
						<b-col>
							<b-form-group
							label="Organization"
							label-size="sm"
							:label-for="`user-organization-filter`"
							>
							<treeselect
							:multiple="false"
							v-model="userOrganizationValue"
							:options="userOrganizationOptions"
							:clearable="true"
							@input="toggleOrganization"
							openDirection="above"
							:maxHeight="120"
							>
						</treeselect>
					</b-form-group>
				</b-col>

				<b-col  lg="auto" md="auto" sm="auto">
					<b-form-group
					label="Role"
					label-size="sm"
					:label-for="`user-filter-role`"
					>
					<b-form-select :id="`user-filter-role`" :options="roleOptions"
					value-field="id"
					text-field="name"
					v-model="filterRole.value"
					@input="filterRole.resetStatus();"
					:state="filterRole.status"
					@change="toggleRole"
					>
				</b-form-select>
			</b-form-group>
		</b-col>
		<b-col lg="auto" md="auto" sm="auto">
			<b-form-group
			label="Status"
			label-size="sm"
			:label-for="`user-filter-status`"
			>
			<b-form-select :id="`user-filter-status`" :options="activeOptions"
			v-model="filterActive.value"
			@input="filterActive.resetStatus()"
			:state="filterActive.status"
			@change="toggleActive"
			>
		</b-form-select>
	</b-form-group>
</b-col>
<b-col v-if="$store.state.isMobile" class="sorting-option">
	<b-form-group
					label="Sort"
					label-size="sm"
					label-cols="auto"
					content-cols="auto"
					label-for="user-filter-sort-by"
				>
					<b-form-select
						id="user-filter-sort-by"
						:options="User.getSortOptions"
						@input="filterSortBy.resetStatus()"
						:state="filterSortBy.status"
						v-model="filterSortBy.value"
						@change="sortByChange"
					/>
				</b-form-group>
</b-col>
<b-col lg="auto" md="auto" sm="auto">
	<b-form-group
	label="Date Created"
	label-size="sm"
	:label-for="`user-filter-from-date`"
	>
	<div class="dates">
		<date-range-picker single-date-picker="range"
			v-if="$store.state.isMobile"
			v-model="filterDate"
			show-dropdowns
			opens="center"
			@update="onDateRangeSelect"
			:ranges="dateRangePickerRanges"
			:auto-apply="true"
			:append-to-body="true"
		>
		<template v-slot:input="picker" style="min-width: 350px;">
			<span v-if="picker.startDate && picker.endDate" v-html="formatDateRange(picker.startDate,picker.endDate)">
			</span>
			<span v-else>Start/End Date</span>
		</template>
		</date-range-picker>

		<date-range-picker single-date-picker="range"
			v-if="!$store.state.isMobile"
			v-model="filterDate"
			show-dropdowns
			opens="left"
			@update="onDateRangeSelect"
			:ranges="dateRangePickerRanges"
			:auto-apply="true"
		>
		<template v-slot:input="picker" style="min-width: 350px;">
			<span v-if="picker.startDate && picker.endDate" v-html="formatDateRange(picker.startDate,picker.endDate)">
			</span>
			<span v-else>Start/End Date</span>
		</template>
		</date-range-picker>


	</div>
</b-form-group>
</b-col>

<b-col id="search-col">
	<!-- <b-button id="search-btn" size="sm" @click="$emit('submit:filters')">Search</b-button> -->
	<div class="search-col__button-wrapper d-flex">
		<b-button id="search-btn" size="sm" @click="setArgs">Search</b-button>
		<b-button class="ml-3" variant="danger" id="reset-filter" @click="resetArgs" v-if="hasAdvancedFilters() && $store.state.isMobile"> Reset</b-button>
	</div>
</b-col>
</b-row>
</b-collapse>
</div>

</div>
<div class="quick-switch-container-wrapper user-quick-switch-container-wrapper-mobile">

	<div class="quick-switch-container container wide">
		<div class="quick-switch hide-mobile">
			<div class="quick-switch__title-standalone">Users</div>
			<div class="quick-switch__sort-by">
				<b-form-group
					label="Sort"
					label-size="sm"
					label-cols="auto"
					content-cols="auto"
					label-for="user-filter-sort-by"
				>
					<b-form-select
						id="user-filter-sort-by"
						:options="User.getSortOptions"
						@input="filterSortBy.resetStatus()"
						:state="filterSortBy.status"
						v-model="filterSortBy.value"
						@change="sortByChange"
					/>
				</b-form-group>
			</div>
		</div>	
		<div v-if="$store.state.isMobile" class="d-flex">
			<div class="user-btns-mobile d-none">
				<button v-if="showNewUserButton" class="quick-switch__action-button btn btn-secondary" @click="$emit('submit:newuser')">
					New User
				</button>
			</div>
			<div class="quick-switch__sort-by hide-mobile">
				<b-form-group
					label="Sort"
					label-size="sm"
					label-cols="auto"
					content-cols="auto"
					label-for="user-filter-sort-by"
				>
					<b-form-select
						id="user-filter-sort-by"
						:options="User.getSortOptions"
						@input="filterSortBy.resetStatus()"
						:state="filterSortBy.status"
						v-model="filterSortBy.value"
						@change="sortByChange"
					/>
				</b-form-group>
			</div>
		</div>
	</div>
</div>
	</div>
</template>

<script>
import Vue from 'vue'
import User from './../models/User'
import treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect'
import BootstrapField from './../utility/BootstrapField';

export default {
	name: 'UserFilters',
	components: {
		treeselect,
	},
	props: {
		columns: Array,
		totals: Object,
		activeList: Number,
		callOptionMethod: String,

		storeArgs:String,
		storeModule:String,
		showNewUserButton:Boolean,
	},
	data: () => ({
		showAdvancedSearch: false,
		showLaneFilter: false,
		arg: {},
		globalSearch: null,
		User,
		filterActive: new BootstrapField({
			value: null,
		}),
		filterRole: new BootstrapField({
			value: null,
		}),
		activeOptions: [{value: null, text: "All"}].concat(User.getActiveOptions),
		roleOptions: [{id: null, name: "All"}].concat(User.getRoleOptions),
		userOrganizationOptions: [{id: null, label: "Any Organization"}],
		isUserOrganizationLoading: false,
		userOrganizationValue: null,
		filterDate: {
			startDate: null,
			endDate: null,
		},
		filterSortBy: new BootstrapField({
			value: 'name asc'
		})
	}),
	mounted() {
		Vue.prototype.$bus.$emit('menu:hasAdvanceFiltersState', this.hasAdvancedFilters());
		Vue.prototype.$bus.$emit('menu:advanceFiltersCount', this.advancedFilterCount());
		this.getAdvancedSearch();
	},
	created() {
		Vue.prototype.$bus.$off('menu:toggleUserAdvanceFilter', this.toggleAdvancedSearch);
		Vue.prototype.$bus.$on('menu:toggleUserAdvanceFilter', this.toggleAdvancedSearch);
		if ( this.columns ) {
			this.columns.forEach(item => {
				if ( item.filter ) {
					if ( (item.filter.autoComplete && item.filter.show) || (item.filter.datepicker && item.filter.show) ) {
						this.getArgs(item.filter)
					}
				}
			})
		}
		this.getOrganizations();
	},

	computed: {
		resetText() {
		    if (this.advancedFilterCount() == 1) {
		      return "Reset " + this.advancedFilterCount() + " filter";
		    } else {
		      return "Reset " + this.advancedFilterCount() + " filters";
		    }
		},
		Totals() {
			let lists = []
			for (let item in this.totals) {
				if (item == "closures") {
					let attr = [],
					total = 0
					for (let key in this.totals[item]) {
						attr.push({
							name: key,
							count: parseInt(this.totals[item][key])
						})
						total += parseInt(this.totals[item][key])
					}
					lists.push({
						taskName: item,
						total,
						status: attr
					})
				}
			}
			return lists
		},
		dateRangePickerRanges() {
            return {
                'No Date': [null, null],
                'Yesterday': [this.$moment().subtract(1, 'days').toDate(), this.$moment().subtract(1, 'days').toDate()],
                'Last week': [this.$moment().subtract(7, 'days').startOf('week').toDate(), this.$moment().subtract(7, 'days').endOf('week').toDate()],
                'Last two week': [this.$moment().subtract(14, 'days').startOf('week').toDate(), this.$moment().subtract(7, 'days').endOf('week').toDate()],
                'Today': [this.$moment().toDate(), this.$moment().toDate()],
                'This week': [this.$moment().startOf('week').toDate(), this.$moment().endOf('week').toDate()],
                'Next week': [this.$moment().startOf('week').add(7, 'days').toDate(), this.$moment().endOf('week').add(7, 'days').toDate()],
                'Next two weeks': [this.$moment().startOf('week').add(7, 'days').toDate(), this.$moment().endOf('week').add(14, 'days').toDate()],
            };
        }	
	},
	methods: {
		hasAdvancedFilters() {
			let response = false;
			for (let item in this.arg) {
				if (this.arg[item] != null && item != "fromDate" && item != "toDate" && item != "isActive" && item != "sortBy" && item != "sortOrder") {
					response = true;
				}
			}
			if (this.filterDate.startDate || this.filterDate.endDate) {
                if (this.filterDate.startDate != "Invalid Date" && this.filterDate.endDate != "Invalid Date") {
                    response = true;
                }
			}
			if (this.filterActive.value !== 1) {
				response = true;
			}
			if (this.filterRole.value) {
				response = true;
			}
			Vue.prototype.$bus.$emit('menu:hasAdvanceFiltersState', response);
			return response;
		},

		advancedFilterCount() {
			let count = 0;
			for (let item in this.arg) {
				if (this.arg[item] != null && item != "fromDate" && item != "toDate" && item != "isActive" && item != "sortBy" && item != "sortOrder") {
					count++;
				}
			}
			if (this.filterDate.startDate || this.filterDate.endDate) {
                if (this.filterDate.startDate != "Invalid Date" && this.filterDate.endDate != "Invalid Date") {
                    count++;
                }
			}
			if (this.filterActive.value !== 1) {
				count++;
			}
			if (this.filterRole.value) {
				count++;
			}
			Vue.prototype.$bus.$emit('menu:advanceFiltersCount', count);
			return count;
		},
		handleAutocomplete(value, instanceId) {
			this.setArgs();
		},

		fieldId(name) {
			return this.storeArgs+"-field-"+name;
		},
		parseLabel(node, argAttr) {
			if ( node.label ) {
				if ( node.label.indexOf('(unknown)') > -1 ) {
					node.label = this.arg[argAttr]
				} else {
					this.arg[argAttr] = node.label
				}
			}
			return node.label
		},

		clickOutsideAdvanceSearch(e) {
			let filterBox = document.getElementById('user-filters-container');
			let advanceSearchBox = document.getElementById('advance-search');
			let laneFilterMessageButton = document.getElementById('list-filter-messages-button');
			let laneFilterUpdateButton = document.getElementById('list-filter-updates-button');
			let keepOpen = false;
			if (advanceSearchBox) {
			  if (advanceSearchBox.contains(e.target)) {
			    keepOpen = true;
			  }
			}
			if (filterBox) {
			  if (filterBox.contains(e.target)) {
			    keepOpen = true;
			  }
			}
			if (laneFilterMessageButton) {
			  if (laneFilterMessageButton.contains(e.target)) {
			    keepOpen = false;
			  }
			}
			if (laneFilterUpdateButton) {
			  if (laneFilterUpdateButton.contains(e.target)) {
			    keepOpen = false;
			  }
			}
			if (!keepOpen) {
			  this.hideAdvanceSearch();
			}
		},
		toggleAdvancedSearch() {
		  this.showAdvancedSearch = !this.showAdvancedSearch
			Vue.prototype.$bus.$emit('menu:advanceFiltersExpandedState', this.showAdvancedSearch);
		  this.saveAdvancedSearch();
		  if(!this.$store.state.isMobile) {
			this.$nextTick(() => {
				if (this.showAdvancedSearch) {
				window.addEventListener('click', this.clickOutsideAdvanceSearch);
				}
				else {
				window.removeEventListener('click', this.clickOutsideAdvanceSearch);
				}
			});
		  }
		},

		hideAdvanceSearch() {
		  if (this.showAdvancedSearch) {
		    this.showAdvancedSearch = false;
		    window.removeEventListener('click', this.clickOutsideAdvanceSearch);
		  }
		},
		saveAdvancedSearch() {
			localStorage.setItem('showAdvancedSearch', this.showAdvancedSearch)
		},
		getAdvanceSearchColumnClasses(field) {
			return 'advance-search__'+field;
		},
		getAdvancedSearch() {
			this.showAdvancedSearch = false;
			/*
			let testValue = localStorage.getItem('showAdvancedSearch');
			if (testValue == "true") {
				this.showAdvancedSearch = true;
			} else {
				this.showAdvancedSearch = false;
			}
			*/
		},
		getOptionSelected(qty) {
			if (qty == 1) {
				return qty + " option selected";
			} else {
				return qty + " options selected"
			}
		},

		searchGlobal() {
			this.arg['keywords'] = this.globalSearch
			this.setArgs()
			this.$emit('submit:filters')
		},





		// onAutoCompleteSubmit(result, value, name, keyField) {
		//     this.arg[keyField] = result[value]
		//     this.setArgValues(keyField, result, name)
		//     this.$emit('update:filters', { [keyField]: result[name] })
		// },




		getArgValues(keyField, label) {
			let argQuery = JSON.parse(localStorage.getItem(this.storeFilter))
			if (argQuery == null) {
				argQuery = {};
			}

			if (argQuery != null) {
				if ( !Array.isArray(argQuery) ) {
					if ( argQuery[keyField] ) {
						this.arg[keyField] = argQuery[keyField]
					}
				}
				if ( !this.arg[keyField] ) {
					this.arg[keyField] = {}
					if ( label ) {
						this.arg[keyField][label] = ''
					}
				}
			}
		},


		clearArgs( filters ) {
			this.arg = {
				...this.arg,
				[filters.key]: null,
				[filters.key+'_label']: null
			}
		},
		getArgs( filters ) {
			let argQuery = JSON.parse(localStorage.getItem(this.storeArgs))
			if (argQuery == null) {
				argQuery = {};
			}
			// if ( this.arg === undefined )

			if ( filters.autoComplete ) {
				this.arg = {
					...this.arg,
					[filters.key]: argQuery[filters.key]
				}
			} else if ( filters.datepicker ) {
				let startMoment = null;
				let endMoment = null;
				if (argQuery[filters.datepicker.from] != undefined) {
					startMoment = this.moment(argQuery[filters.datepicker.from]);
					if (startMoment.isValid()) {
					    startMoment.hours(0);
					    startMoment.minutes(0);
					    startMoment.seconds(0);
				this.arg = {
					...this.arg,
						    [filters.datepicker.from]: startMoment.format(),
						}
						this.filterDate.startDate = new Date(startMoment.format());
					} else {
						argQuery[filters.datepicker.from] = null;
						this.arg = {
						    ...this.arg,
						    [filters.datepicker.from]: null,
						}
						this.filterDate.startDate = null;
					}
				}
				if (argQuery[filters.datepicker.to] != undefined) {
					endMoment = this.moment(argQuery[filters.datepicker.to]);
					if (endMoment.isValid()) {
					    endMoment.hours(23);
					    endMoment.minutes(59);
					    endMoment.seconds(59);
					    this.arg = {
					        ...this.arg,
					        [filters.datepicker.to]: endMoment.format(),
					    }
					    this.filterDate.endDate = new Date(endMoment.format());
					} else {
						argQuery[filters.datepicker.to] = null;
						this.arg = {
						    ...this.arg,
						    [filters.datepicker.to]: null,
						}
						this.filterDate.endDate = null;
					}
				}
			}
			// pull in the global search and completed request filter.
			if (argQuery != null) {
				if (argQuery.keywords) {
					this.globalSearch = argQuery.keywords;
				} else {
					this.globalSearch = null;
				}
				// pull in the data
				this.arg = argQuery;
				// pull in select data
				if(argQuery.isActive !== undefined) this.filterActive.value = argQuery.isActive
				if(argQuery.roleId !== undefined) this.filterRole.value = argQuery.roleId
				if(argQuery.organization !== undefined) this.userOrganizationValue = argQuery.organization;
				if (argQuery.sortOrder && argQuery.sortBy) {
                    this.filterSortBy.value = argQuery.sortBy + " " + argQuery.sortOrder;
                    this.arg['sortBy'] = argQuery.sortBy;
                    this.arg['sortOrder'] = argQuery.sortOrder;
                }
		}
	},
	setArgs() {
		this.showAdvancedSearch = false;
		Vue.prototype.$bus.$emit('menu:advanceFiltersExpandedState', this.showAdvancedSearch);
		if (this.arg['organization'] === undefined) {
			this.arg['organization'] = null;
		}

		localStorage.setItem(this.storeArgs, JSON.stringify(this.arg))
		this.$emit('submit:filters')
	},
	resetArgs() {
		this.arg = Array()
		this.globalSearch = "";
		this.filterActive = new BootstrapField({ value: null });
		this.filterRole = new BootstrapField({ value: null });
		this.userOrganizationValue = null;
		this.filterDate = { startDate: null, endDate: null };
		this.$store.dispatch(this.storeModule+'/clearParams');
		this.columns.map(elem => {
			if (elem.filter != undefined ) {
				if (elem.filter.show) {
					this.clearArgs(elem.filter)
				}
			}
		})
		this.filterActive.value = 1;
		this.toggleActive();
		this.setArgs()
		this.showAdvancedSearch = false
		Vue.prototype.$bus.$emit('menu:advanceFiltersExpandedState', this.showAdvancedSearch);
		Vue.prototype.$bus.$emit('menu:advanceFiltersCount', 0);
		this.saveAdvancedSearch();
	},

	onDatePickerChange(input, keyField) {
		let theDate = this.moment(input);
		let dateString = null;
		if (theDate.isValid()) {
			if (keyField == "fromDate") {
				theDate.hours(0);
				theDate.minutes(0);
				theDate.seconds(0);
			}
			if (keyField == "toDate") {
				theDate.hours(23);
				theDate.minutes(59);
				theDate.seconds(59);
			}
			dateString = theDate.format();
		}

		this.arg = {
			...this.arg,
			[keyField]: dateString
		}



	},

	toggleActive() {
		this.arg['isActive'] = this.filterActive.value;
	},
	toggleRole() {
		this.arg['roleId'] = this.filterRole.value;
	},
	toggleOrganization() {
		this.arg['organization'] = this.userOrganizationValue;
	},
	hasFilter() {
		return (this.globalSearch || this.filterActive.value != null ||
		this.filterRole.value != null || this.arg.fromDate || this.arg.toDate ||
		this.userOrganizationValue);
	},
	clearSearch() {
		this.globalSearch = null;
			// this.searchGlobal();
		},

		onUserOrganizationSearch({ action, searchQuery, callback }) {
			if (action !== ASYNC_SEARCH) {
				return;
			}

			this.isUserOrganizationLoading = true;
			this.$store.dispatch(this.columns[1]['filter']['autoComplete']['search'], searchQuery)
			.then(res => {
				this.userOrganizationOptions = [];
				// var item = {
				// 	id: null,
				// 	label: 'Any Organization',
				// }
				// this.userOrganizationOptions.push(item);

				let resultSet = [];
				let refSet = [];
				let currentLevel = 1;
				let continueLoop = true;

				while (continueLoop) {
					if (currentLevel == 1) {
						res.forEach(x => {
							if (x.level == 1) {
								resultSet.push({
									id: x.id,
									label: x.name,
								});
							}
						});
						refSet = resultSet;
					}
					else {
						let newRef = [];
						res.forEach(x => {
							if (x.level == currentLevel) {
								let org = {
									id: x.id,
									label: x.name,
									parentId: x.parentId,
								};

								newRef.push(org);
							}
						});

						newRef.forEach(x => {
							refSet.forEach(y => {
								if (x.parentId == y.id) {
									if (y.children == undefined) y.children = [];
									y.children.push(x);
								}
							});
						});

						refSet = newRef;
					}
					currentLevel++;
					if (refSet.length == 0) {
						continueLoop = false;
					}
				}

				this.userOrganizationOptions = resultSet;
				callback(null, this.userOrganizationOptions);
			});
		},
		onUserOrganizationInput(filter) {

		},

		getOrganizations() {
			this.isUserOrganizationLoading = true;
			this.$store.dispatch(this.columns[1]['filter']['autoComplete']['search'], "")
			.then(res => {
				this.userOrganizationOptions = [];
				// var item = {
				// 	id: null,
				// 	label: 'Any Organization',
				// }
				// this.userOrganizationOptions.push(item);

				let resultSet = [];
				let refSet = [];
				let currentLevel = 1;
				let continueLoop = true;

				while (continueLoop) {
					if (currentLevel == 1) {
						res.forEach(x => {
							if (x.level == 1) {
								resultSet.push({
									id: x.id,
									label: x.name,
								});
							}
						});
						refSet = resultSet;
					}
					else {
						let newRef = [];
						res.forEach(x => {
							if (x.level == currentLevel) {
								let org = {
									id: x.id,
									label: x.name,
									parentId: x.parentId,
								};

								newRef.push(org);
							}
						});

						newRef.forEach(x => {
							refSet.forEach(y => {
								if (x.parentId == y.id) {
									if (y.children == undefined) y.children = [];
									y.children.push(x);
								}
							});
						});

						refSet = newRef;
					}
					currentLevel++;
					if (refSet.length == 0) {
						continueLoop = false;
					}
				}
				this.userOrganizationOptions = resultSet;
			});
		},

		onDateRangeSelect(date) {
            let startMoment = this.moment(date.startDate);
            let endMoment = this.moment(date.endDate);

            if (startMoment.isValid()) {
                startMoment.hours(0);
                startMoment.minutes(0);
                startMoment.seconds(0);
            }
            if (endMoment.isValid()) {
                endMoment.hours(23);
                endMoment.minutes(59);
                endMoment.seconds(59);
            }

            this.arg = {
                ...this.arg,
                fromDate: startMoment.format() == "Invalid date" ?  null : startMoment.format(),
                toDate: endMoment.format() == "Invalid date" ? null : endMoment.format(),
            }
            // this.setArgs()
            // this.$emit('submit:filters')

		},
		formatDateRange(startDate,endDate) {
            let sd = this.$moment(startDate);
            let ed = this.$moment(endDate);
            return sd.format('MM/DD/YYYY') + " - " + ed.format('MM/DD/YYYY');
        },

		sortByChange(val) {
            if (val) {
                let vals = val.split(" ");
                this.arg['sortBy'] = vals[0];
                this.arg['sortOrder'] = vals[1];
            }
            else {
                this.arg['sortBy'] = this.arg['sortOrder'] = null;
            }
            this.setArgs();
            // this.$emit("submit:filters");
        },

        changeSortFromColumn(sortBy, sortOrder) {
            this.filterSortBy.value = sortBy + " " + sortOrder;
            this.sortByChange(this.filterSortBy.value);
        },
	}
}
</script>
